<template>
  <div id="resetPasswordWrapper">
    <div class="columns is-centered">
      <div class="column is-one-quarter">
        <div id="signin" class="card">
          <div class="card-header">
            <p class="card-header-title">Wachtwoord herstellen</p>
          </div>

          <div class="card-content">
            <template v-if="token">
              <div v-show="reset" class="notification is-success">
                Uw nieuwe wachtwoord is opgeslagen. U kunt nu <router-link :to="{ name: 'signin' }">inloggen</router-link> met het nieuwe wachtwoord.
              </div>

              <div class="field">
                <label for="password" class="label">Nieuw wachtwoord</label>

                <div class="control">
                  <input class="input" type="password" name="password" v-model="password">
                </div>
              </div>

              <div class="field">
                <label for="password_verification" class="label">Nogmaals het nieuwe wachtwoord</label>

                <div class="control">
                  <input class="input" type="password" name="password_verification" v-model="passwordVerification">
                </div>
              </div>

              <div class="field">
                <button type="button" class="button" @click="resetPassword" :disabled="!validPassword">Nieuw wachtwoord opslaan</button>
              </div>
            </template>

            <template v-else>
              <div v-show="sent" class="notification is-info">
                Uw verzoek is verzonden. Er is een e-mail verstuurd naar {{ this.email }} met een link waarmee u een nieuw wachtwoord kunt maken indien het adres bekend is in onze database.
              </div>

              <div class="field">
                <label for="email" class="label">E-mail adres</label>

                <div class="control">
                  <input class="input" type="text" name="email" v-model="email">
                </div>
              </div>

              <div class="field">
                <button type="button" class="button" @click="requestResetToken" :disabled="!validEmail">Versturen</button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      email: null,
      password: null,
      passwordVerification: null,
      sent: false,
      reset: false
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    validEmail () {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.email).toLowerCase())
    },
    validPassword () {
      if (this.password) {
        return this.password.length >= 8 && this.password === this.passwordVerification
      }

      return false
    }
  },
  methods: {
    requestResetToken () {
      axios.post(
        '/auth/reset-password',
        {
          email: this.email
        }
      ).then(
        (res) => {
          this.sent = true
        }
      ).catch(
        (err) => console.error(err)
      )
    },
    resetPassword () {
      axios.post(
        'auth/change-password',
        {
          token: this.token,
          password: this.password,
          password_verification: this.passwordVerification
        }
      ).then(
        (res) => {
          this.reset = true
        }
      ).catch(
        (err) => {
          console.error(err)
        }
      )
    }
  }
}
</script>

<style scoped>
  #signin {
    top: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue